var instantAnimationState = {
    current: false,
};

export { instantAnimationState };
